var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolioActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13123 2.32507L11.8187 3.96257C12.8812 4.43132 12.8812 5.20632 11.8187 5.67507L8.13123 7.31257C7.71248 7.50007 7.02498 7.50007 6.60623 7.31257L2.91873 5.67507C1.85623 5.20632 1.85623 4.43132 2.91873 3.96257L6.60623 2.32507C7.02498 2.13757 7.71248 2.13757 8.13123 2.32507Z",
    stroke: "#EEFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 8.45312C1.875 8.97812 2.26875 9.58437 2.75 9.79687L6.99375 11.6844C7.31875 11.8281 7.6875 11.8281 8.00625 11.6844L12.25 9.79687C12.7313 9.58437 13.125 8.97812 13.125 8.45312",
    stroke: "#EEFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 12.7922C1.875 13.3735 2.21875 13.8985 2.75 14.136L6.99375 16.0235C7.31875 16.1672 7.6875 16.1672 8.00625 16.0235L12.25 14.136C12.7813 13.8985 13.125 13.3735 13.125 12.7922",
    stroke: "#EEFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioActive);
export default __webpack_public_path__ + "static/media/portfolio-active.cbeb09d34665cfdd9d59739edcb930a7.svg";
export { ForwardRef as ReactComponent };